import auth from './auth';
import usuario from './usuario';
import loader from './loader';

const modules = { auth, loader, usuario };

export default modules;
